import { useState } from "react";
import { login } from "../services/api";

export default function Login({ setToken, goToSignup }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await login({ email, password });

      if (res.data.error) {
        setError(res.data.error);
        setLoading(false);
        return;
      }

      localStorage.setItem("token", res.data.token);
      setToken(res.data.token);
    } catch {
      setError("Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col md:flex-row">
      
      {/* LEFT PANEL */}
      <div className="md:w-1/2 bg-gradient-to-br from-blue-900 to-blue-600 text-white p-10 flex flex-col justify-center">
        
        <h1 className="text-4xl font-bold mb-4">
          🚀 AI-Powered Test Case Generator
        </h1>

        <p className="mb-4 text-sm md:text-base">
          Generate intelligent test cases directly from requirements using AI.
        </p>

        <ul className="space-y-2 text-sm md:text-base">
          <li>✔ AI-generated test cases with structured output</li>
          <li>✔ Missing scenario detection</li>
          <li>✔ Risk analysis for better coverage</li>
          <li>✔ Context-aware testing using uploaded documents</li>
          <li>✔ History tracking for all test runs</li>
        </ul>

        <p className="mt-6 font-semibold">
          Built to reduce manual effort and accelerate your QA process.
        </p>
      </div>

      {/* RIGHT PANEL */}
      <div className="md:w-1/2 flex items-center justify-center p-6 bg-gray-50">
        <form
          onSubmit={handleLogin}
          className="w-full max-w-sm bg-white p-8 rounded-2xl shadow-lg"
        >
          <h2 className="text-2xl font-semibold mb-6 text-center">
            Login
          </h2>

          {error && (
            <p className="text-red-500 text-sm mb-3 text-center">{error}</p>
          )}

          <input
            type="email"
            placeholder="Email"
            className="w-full mb-4 px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="Password"
            className="w-full mb-4 px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-700 text-white py-2 rounded-lg hover:bg-blue-800 transition disabled:opacity-50"
          >
            {loading ? "Logging in..." : "Login"}
          </button>

          <p className="text-sm text-center mt-4">
            New user?{" "}
            <span
              onClick={goToSignup}
              className="text-blue-600 cursor-pointer hover:underline"
            >
              Signup
            </span>
          </p>
        </form>
      </div>
    </div>
  );
}